export interface Country {
  countryCode: string;
  name: string;
  countryPhoneCode: string;
}

// Countries data based on MUI's country select example
export const countries: Country[] = [
  { countryCode: "AD", name: "Andorra", countryPhoneCode: "376" },
  {
    countryCode: "AE",
    name: "United Arab Emirates",
    countryPhoneCode: "971",
  },
  { countryCode: "AF", name: "Afghanistan", countryPhoneCode: "93" },
  {
    countryCode: "AG",
    name: "Antigua and Barbuda",
    countryPhoneCode: "1-268",
  },
  { countryCode: "AI", name: "Anguilla", countryPhoneCode: "1-264" },
  { countryCode: "AL", name: "Albania", countryPhoneCode: "355" },
  { countryCode: "AM", name: "Armenia", countryPhoneCode: "374" },
  { countryCode: "AO", name: "Angola", countryPhoneCode: "244" },
  { countryCode: "AQ", name: "Antarctica", countryPhoneCode: "672" },
  { countryCode: "AR", name: "Argentina", countryPhoneCode: "54" },
  { countryCode: "AS", name: "American Samoa", countryPhoneCode: "1-684" },
  { countryCode: "AT", name: "Austria", countryPhoneCode: "43" },
  {
    countryCode: "AU",
    name: "Australia",
    countryPhoneCode: "61",
  },
  { countryCode: "AW", name: "Aruba", countryPhoneCode: "297" },
  { countryCode: "AX", name: "Alland Islands", countryPhoneCode: "358" },
  { countryCode: "AZ", name: "Azerbaijan", countryPhoneCode: "994" },
  {
    countryCode: "BA",
    name: "Bosnia and Herzegovina",
    countryPhoneCode: "387",
  },
  { countryCode: "BB", name: "Barbados", countryPhoneCode: "1-246" },
  { countryCode: "BD", name: "Bangladesh", countryPhoneCode: "880" },
  { countryCode: "BE", name: "Belgium", countryPhoneCode: "32" },
  { countryCode: "BF", name: "Burkina Faso", countryPhoneCode: "226" },
  { countryCode: "BG", name: "Bulgaria", countryPhoneCode: "359" },
  { countryCode: "BH", name: "Bahrain", countryPhoneCode: "973" },
  { countryCode: "BI", name: "Burundi", countryPhoneCode: "257" },
  { countryCode: "BJ", name: "Benin", countryPhoneCode: "229" },
  { countryCode: "BL", name: "Saint Barthelemy", countryPhoneCode: "590" },
  { countryCode: "BM", name: "Bermuda", countryPhoneCode: "1-441" },
  { countryCode: "BN", name: "Brunei Darussalam", countryPhoneCode: "673" },
  { countryCode: "BO", name: "Bolivia", countryPhoneCode: "591" },
  { countryCode: "BR", name: "Brazil", countryPhoneCode: "55" },
  { countryCode: "BS", name: "Bahamas", countryPhoneCode: "1-242" },
  { countryCode: "BT", name: "Bhutan", countryPhoneCode: "975" },
  { countryCode: "BV", name: "Bouvet Island", countryPhoneCode: "47" },
  { countryCode: "BW", name: "Botswana", countryPhoneCode: "267" },
  { countryCode: "BY", name: "Belarus", countryPhoneCode: "375" },
  { countryCode: "BZ", name: "Belize", countryPhoneCode: "501" },
  {
    countryCode: "CA",
    name: "Canada",
    countryPhoneCode: "1",
  },
  {
    countryCode: "CC",
    name: "Cocos (Keeling) Islands",
    countryPhoneCode: "61",
  },
  {
    countryCode: "CD",
    name: "Congo, Democratic Republic of the",
    countryPhoneCode: "243",
  },
  {
    countryCode: "CF",
    name: "Central African Republic",
    countryPhoneCode: "236",
  },
  {
    countryCode: "CG",
    name: "Congo, Republic of the",
    countryPhoneCode: "242",
  },
  { countryCode: "CH", name: "Switzerland", countryPhoneCode: "41" },
  { countryCode: "CI", name: "Cote d'Ivoire", countryPhoneCode: "225" },
  { countryCode: "CK", name: "Cook Islands", countryPhoneCode: "682" },
  { countryCode: "CL", name: "Chile", countryPhoneCode: "56" },
  { countryCode: "CM", name: "Cameroon", countryPhoneCode: "237" },
  { countryCode: "CN", name: "China", countryPhoneCode: "86" },
  { countryCode: "CO", name: "Colombia", countryPhoneCode: "57" },
  { countryCode: "CR", name: "Costa Rica", countryPhoneCode: "506" },
  { countryCode: "CU", name: "Cuba", countryPhoneCode: "53" },
  { countryCode: "CV", name: "Cape Verde", countryPhoneCode: "238" },
  { countryCode: "CW", name: "Curacao", countryPhoneCode: "599" },
  { countryCode: "CX", name: "Christmas Island", countryPhoneCode: "61" },
  { countryCode: "CY", name: "Cyprus", countryPhoneCode: "357" },
  { countryCode: "CZ", name: "Czech Republic", countryPhoneCode: "420" },
  {
    countryCode: "DE",
    name: "Germany",
    countryPhoneCode: "49",
  },
  { countryCode: "DJ", name: "Djibouti", countryPhoneCode: "253" },
  { countryCode: "DK", name: "Denmark", countryPhoneCode: "45" },
  { countryCode: "DM", name: "Dominica", countryPhoneCode: "1-767" },
  {
    countryCode: "DO",
    name: "Dominican Republic",
    countryPhoneCode: "1-809",
  },
  { countryCode: "DZ", name: "Algeria", countryPhoneCode: "213" },
  { countryCode: "EC", name: "Ecuador", countryPhoneCode: "593" },
  { countryCode: "EE", name: "Estonia", countryPhoneCode: "372" },
  { countryCode: "EG", name: "Egypt", countryPhoneCode: "20" },
  { countryCode: "EH", name: "Western Sahara", countryPhoneCode: "212" },
  { countryCode: "ER", name: "Eritrea", countryPhoneCode: "291" },
  { countryCode: "ES", name: "Spain", countryPhoneCode: "34" },
  { countryCode: "ET", name: "Ethiopia", countryPhoneCode: "251" },
  { countryCode: "FI", name: "Finland", countryPhoneCode: "358" },
  { countryCode: "FJ", name: "Fiji", countryPhoneCode: "679" },
  {
    countryCode: "FK",
    name: "Falkland Islands (Malvinas)",
    countryPhoneCode: "500",
  },
  {
    countryCode: "FM",
    name: "Micronesia, Federated States of",
    countryPhoneCode: "691",
  },
  { countryCode: "FO", name: "Faroe Islands", countryPhoneCode: "298" },
  {
    countryCode: "FR",
    name: "France",
    countryPhoneCode: "33",
  },
  { countryCode: "GA", name: "Gabon", countryPhoneCode: "241" },
  { countryCode: "GB", name: "United Kingdom", countryPhoneCode: "44" },
  { countryCode: "GD", name: "Grenada", countryPhoneCode: "1-473" },
  { countryCode: "GE", name: "Georgia", countryPhoneCode: "995" },
  { countryCode: "GF", name: "French Guiana", countryPhoneCode: "594" },
  { countryCode: "GG", name: "Guernsey", countryPhoneCode: "44" },
  { countryCode: "GH", name: "Ghana", countryPhoneCode: "233" },
  { countryCode: "GI", name: "Gibraltar", countryPhoneCode: "350" },
  { countryCode: "GL", name: "Greenland", countryPhoneCode: "299" },
  { countryCode: "GM", name: "Gambia", countryPhoneCode: "220" },
  { countryCode: "GN", name: "Guinea", countryPhoneCode: "224" },
  { countryCode: "GP", name: "Guadeloupe", countryPhoneCode: "590" },
  { countryCode: "GQ", name: "Equatorial Guinea", countryPhoneCode: "240" },
  { countryCode: "GR", name: "Greece", countryPhoneCode: "30" },
  {
    countryCode: "GS",
    name: "South Georgia and the South Sandwich Islands",
    countryPhoneCode: "500",
  },
  { countryCode: "GT", name: "Guatemala", countryPhoneCode: "502" },
  { countryCode: "GU", name: "Guam", countryPhoneCode: "1-671" },
  { countryCode: "GW", name: "Guinea-Bissau", countryPhoneCode: "245" },
  { countryCode: "GY", name: "Guyana", countryPhoneCode: "592" },
  { countryCode: "HK", name: "Hong Kong", countryPhoneCode: "852" },
  {
    countryCode: "HM",
    name: "Heard Island and McDonald Islands",
    countryPhoneCode: "672",
  },
  { countryCode: "HN", name: "Honduras", countryPhoneCode: "504" },
  { countryCode: "HR", name: "Croatia", countryPhoneCode: "385" },
  { countryCode: "HT", name: "Haiti", countryPhoneCode: "509" },
  { countryCode: "HU", name: "Hungary", countryPhoneCode: "36" },
  { countryCode: "ID", name: "Indonesia", countryPhoneCode: "62" },
  { countryCode: "IE", name: "Ireland", countryPhoneCode: "353" },
  { countryCode: "IM", name: "Isle of Man", countryPhoneCode: "44" },
  { countryCode: "IN", name: "India", countryPhoneCode: "91" },
  {
    countryCode: "IO",
    name: "British Indian Ocean Territory",
    countryPhoneCode: "246",
  },
  { countryCode: "IQ", name: "Iraq", countryPhoneCode: "964" },
  {
    countryCode: "IR",
    name: "Iran, Islamic Republic of",
    countryPhoneCode: "98",
  },
  { countryCode: "IS", name: "Iceland", countryPhoneCode: "354" },
  { countryCode: "IT", name: "Italy", countryPhoneCode: "39" },
  { countryCode: "JE", name: "Jersey", countryPhoneCode: "44" },
  { countryCode: "JM", name: "Jamaica", countryPhoneCode: "1-876" },
  { countryCode: "JO", name: "Jordan", countryPhoneCode: "962" },
  {
    countryCode: "JP",
    name: "Japan",
    countryPhoneCode: "81",
  },
  { countryCode: "KE", name: "Kenya", countryPhoneCode: "254" },
  { countryCode: "KG", name: "Kyrgyzstan", countryPhoneCode: "996" },
  { countryCode: "KH", name: "Cambodia", countryPhoneCode: "855" },
  { countryCode: "KI", name: "Kiribati", countryPhoneCode: "686" },
  { countryCode: "KM", name: "Comoros", countryPhoneCode: "269" },
  {
    countryCode: "KN",
    name: "Saint Kitts and Nevis",
    countryPhoneCode: "1-869",
  },
  {
    countryCode: "KP",
    name: "Korea, Democratic People's Republic of",
    countryPhoneCode: "850",
  },
  { countryCode: "KR", name: "Korea, Republic of", countryPhoneCode: "82" },
  { countryCode: "KW", name: "Kuwait", countryPhoneCode: "965" },
  { countryCode: "KY", name: "Cayman Islands", countryPhoneCode: "1-345" },
  { countryCode: "KZ", name: "Kazakhstan", countryPhoneCode: "7" },
  {
    countryCode: "LA",
    name: "Lao People's Democratic Republic",
    countryPhoneCode: "856",
  },
  { countryCode: "LB", name: "Lebanon", countryPhoneCode: "961" },
  { countryCode: "LC", name: "Saint Lucia", countryPhoneCode: "1-758" },
  { countryCode: "LI", name: "Liechtenstein", countryPhoneCode: "423" },
  { countryCode: "LK", name: "Sri Lanka", countryPhoneCode: "94" },
  { countryCode: "LR", name: "Liberia", countryPhoneCode: "231" },
  { countryCode: "LS", name: "Lesotho", countryPhoneCode: "266" },
  { countryCode: "LT", name: "Lithuania", countryPhoneCode: "370" },
  { countryCode: "LU", name: "Luxembourg", countryPhoneCode: "352" },
  { countryCode: "LV", name: "Latvia", countryPhoneCode: "371" },
  { countryCode: "LY", name: "Libya", countryPhoneCode: "218" },
  { countryCode: "MA", name: "Morocco", countryPhoneCode: "212" },
  { countryCode: "MC", name: "Monaco", countryPhoneCode: "377" },
  {
    countryCode: "MD",
    name: "Moldova, Republic of",
    countryPhoneCode: "373",
  },
  { countryCode: "ME", name: "Montenegro", countryPhoneCode: "382" },
  {
    countryCode: "MF",
    name: "Saint Martin (French part)",
    countryPhoneCode: "590",
  },
  { countryCode: "MG", name: "Madagascar", countryPhoneCode: "261" },
  { countryCode: "MH", name: "Marshall Islands", countryPhoneCode: "692" },
  {
    countryCode: "MK",
    name: "Macedonia, the Former Yugoslav Republic of",
    countryPhoneCode: "389",
  },
  { countryCode: "ML", name: "Mali", countryPhoneCode: "223" },
  { countryCode: "MM", name: "Myanmar", countryPhoneCode: "95" },
  { countryCode: "MN", name: "Mongolia", countryPhoneCode: "976" },
  { countryCode: "MO", name: "Macao", countryPhoneCode: "853" },
  {
    countryCode: "MP",
    name: "Northern Mariana Islands",
    countryPhoneCode: "1-670",
  },
  { countryCode: "MQ", name: "Martinique", countryPhoneCode: "596" },
  { countryCode: "MR", name: "Mauritania", countryPhoneCode: "222" },
  { countryCode: "MS", name: "Montserrat", countryPhoneCode: "1-664" },
  { countryCode: "MT", name: "Malta", countryPhoneCode: "356" },
  { countryCode: "MU", name: "Mauritius", countryPhoneCode: "230" },
  { countryCode: "MV", name: "Maldives", countryPhoneCode: "960" },
  { countryCode: "MW", name: "Malawi", countryPhoneCode: "265" },
  { countryCode: "MX", name: "Mexico", countryPhoneCode: "52" },
  { countryCode: "MY", name: "Malaysia", countryPhoneCode: "60" },
  { countryCode: "MZ", name: "Mozambique", countryPhoneCode: "258" },
  { countryCode: "NA", name: "Namibia", countryPhoneCode: "264" },
  { countryCode: "NC", name: "New Caledonia", countryPhoneCode: "687" },
  { countryCode: "NE", name: "Niger", countryPhoneCode: "227" },
  { countryCode: "NF", name: "Norfolk Island", countryPhoneCode: "672" },
  { countryCode: "NG", name: "Nigeria", countryPhoneCode: "234" },
  { countryCode: "NI", name: "Nicaragua", countryPhoneCode: "505" },
  { countryCode: "NL", name: "Netherlands", countryPhoneCode: "31" },
  { countryCode: "NO", name: "Norway", countryPhoneCode: "47" },
  { countryCode: "NP", name: "Nepal", countryPhoneCode: "977" },
  { countryCode: "NR", name: "Nauru", countryPhoneCode: "674" },
  { countryCode: "NU", name: "Niue", countryPhoneCode: "683" },
  { countryCode: "NZ", name: "New Zealand", countryPhoneCode: "64" },
  { countryCode: "OM", name: "Oman", countryPhoneCode: "968" },
  { countryCode: "PA", name: "Panama", countryPhoneCode: "507" },
  { countryCode: "PE", name: "Peru", countryPhoneCode: "51" },
  { countryCode: "PF", name: "French Polynesia", countryPhoneCode: "689" },
  { countryCode: "PG", name: "Papua New Guinea", countryPhoneCode: "675" },
  { countryCode: "PH", name: "Philippines", countryPhoneCode: "63" },
  { countryCode: "PK", name: "Pakistan", countryPhoneCode: "92" },
  { countryCode: "PL", name: "Poland", countryPhoneCode: "48" },
  {
    countryCode: "PM",
    name: "Saint Pierre and Miquelon",
    countryPhoneCode: "508",
  },
  { countryCode: "PN", name: "Pitcairn", countryPhoneCode: "870" },
  { countryCode: "PR", name: "Puerto Rico", countryPhoneCode: "1" },
  {
    countryCode: "PS",
    name: "Palestine, State of",
    countryPhoneCode: "970",
  },
  { countryCode: "PT", name: "Portugal", countryPhoneCode: "351" },
  { countryCode: "PW", name: "Palau", countryPhoneCode: "680" },
  { countryCode: "PY", name: "Paraguay", countryPhoneCode: "595" },
  { countryCode: "QA", name: "Qatar", countryPhoneCode: "974" },
  { countryCode: "RE", name: "Reunion", countryPhoneCode: "262" },
  { countryCode: "RO", name: "Romania", countryPhoneCode: "40" },
  { countryCode: "RS", name: "Serbia", countryPhoneCode: "381" },
  { countryCode: "RU", name: "Russian Federation", countryPhoneCode: "7" },
  { countryCode: "RW", name: "Rwanda", countryPhoneCode: "250" },
  { countryCode: "SA", name: "Saudi Arabia", countryPhoneCode: "966" },
  { countryCode: "SB", name: "Solomon Islands", countryPhoneCode: "677" },
  { countryCode: "SC", name: "Seychelles", countryPhoneCode: "248" },
  { countryCode: "SD", name: "Sudan", countryPhoneCode: "249" },
  { countryCode: "SE", name: "Sweden", countryPhoneCode: "46" },
  { countryCode: "SG", name: "Singapore", countryPhoneCode: "65" },
  { countryCode: "SH", name: "Saint Helena", countryPhoneCode: "290" },
  { countryCode: "SI", name: "Slovenia", countryPhoneCode: "386" },
  {
    countryCode: "SJ",
    name: "Svalbard and Jan Mayen",
    countryPhoneCode: "47",
  },
  { countryCode: "SK", name: "Slovakia", countryPhoneCode: "421" },
  { countryCode: "SL", name: "Sierra Leone", countryPhoneCode: "232" },
  { countryCode: "SM", name: "San Marino", countryPhoneCode: "378" },
  { countryCode: "SN", name: "Senegal", countryPhoneCode: "221" },
  { countryCode: "SO", name: "Somalia", countryPhoneCode: "252" },
  { countryCode: "SR", name: "Suriname", countryPhoneCode: "597" },
  { countryCode: "SS", name: "South Sudan", countryPhoneCode: "211" },
  {
    countryCode: "ST",
    name: "Sao Tome and Principe",
    countryPhoneCode: "239",
  },
  { countryCode: "SV", name: "El Salvador", countryPhoneCode: "503" },
  {
    countryCode: "SX",
    name: "Sint Maarten (Dutch part)",
    countryPhoneCode: "1-721",
  },
  {
    countryCode: "SY",
    name: "Syrian Arab Republic",
    countryPhoneCode: "963",
  },
  { countryCode: "SZ", name: "Swaziland", countryPhoneCode: "268" },
  {
    countryCode: "TC",
    name: "Turks and Caicos Islands",
    countryPhoneCode: "1-649",
  },
  { countryCode: "TD", name: "Chad", countryPhoneCode: "235" },
  {
    countryCode: "TF",
    name: "French Southern Territories",
    countryPhoneCode: "262",
  },
  { countryCode: "TG", name: "Togo", countryPhoneCode: "228" },
  { countryCode: "TH", name: "Thailand", countryPhoneCode: "66" },
  { countryCode: "TJ", name: "Tajikistan", countryPhoneCode: "992" },
  { countryCode: "TK", name: "Tokelau", countryPhoneCode: "690" },
  { countryCode: "TL", name: "Timor-Leste", countryPhoneCode: "670" },
  { countryCode: "TM", name: "Turkmenistan", countryPhoneCode: "993" },
  { countryCode: "TN", name: "Tunisia", countryPhoneCode: "216" },
  { countryCode: "TO", name: "Tonga", countryPhoneCode: "676" },
  { countryCode: "TR", name: "Turkey", countryPhoneCode: "90" },
  {
    countryCode: "TT",
    name: "Trinidad and Tobago",
    countryPhoneCode: "1-868",
  },
  { countryCode: "TV", name: "Tuvalu", countryPhoneCode: "688" },
  {
    countryCode: "TW",
    name: "Taiwan",
    countryPhoneCode: "886",
  },
  {
    countryCode: "TZ",
    name: "United Republic of Tanzania",
    countryPhoneCode: "255",
  },
  { countryCode: "UA", name: "Ukraine", countryPhoneCode: "380" },
  { countryCode: "UG", name: "Uganda", countryPhoneCode: "256" },
  {
    countryCode: "US",
    name: "United States",
    countryPhoneCode: "1",
  },
  { countryCode: "UY", name: "Uruguay", countryPhoneCode: "598" },
  { countryCode: "UZ", name: "Uzbekistan", countryPhoneCode: "998" },
  {
    countryCode: "VA",
    name: "Holy See (Vatican City State)",
    countryPhoneCode: "379",
  },
  {
    countryCode: "VC",
    name: "Saint Vincent and the Grenadines",
    countryPhoneCode: "1-784",
  },
  { countryCode: "VE", name: "Venezuela", countryPhoneCode: "58" },
  {
    countryCode: "VG",
    name: "British Virgin Islands",
    countryPhoneCode: "1-284",
  },
  {
    countryCode: "VI",
    name: "US Virgin Islands",
    countryPhoneCode: "1-340",
  },
  { countryCode: "VN", name: "Vietnam", countryPhoneCode: "84" },
  { countryCode: "VU", name: "Vanuatu", countryPhoneCode: "678" },
  { countryCode: "WF", name: "Wallis and Futuna", countryPhoneCode: "681" },
  { countryCode: "WS", name: "Samoa", countryPhoneCode: "685" },
  { countryCode: "XK", name: "Kosovo", countryPhoneCode: "383" },
  { countryCode: "YE", name: "Yemen", countryPhoneCode: "967" },
  { countryCode: "YT", name: "Mayotte", countryPhoneCode: "262" },
  { countryCode: "ZA", name: "South Africa", countryPhoneCode: "27" },
  { countryCode: "ZM", name: "Zambia", countryPhoneCode: "260" },
  { countryCode: "ZW", name: "Zimbabwe", countryPhoneCode: "263" },
];
